import * as React from "react";
const SvgFiRrGlassCitrus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-glass-citrus_svg__a)">
      <path
        fill="#062147"
        d="M17.5 0c-3.073 0-5.655 2.145-6.33 5.016H3.006c-.914 0-1.767.409-2.34 1.122-.571.713-.786 1.633-.603 2.445l1.51 11.042a5.01 5.01 0 0 0 4.962 4.378h7.004a5.004 5.004 0 0 0 4.959-4.367l1.499-10.973a2.99 2.99 0 0 0-.591-2.526 2.99 2.99 0 0 0-2.34-1.122h-3.814a4.51 4.51 0 0 1 4.248-3.016c2.48 0 4.5 2.019 4.5 4.5v.01a5.1 5.1 0 0 1-.41 1.819 1 1 0 0 0 1.833.801 7.1 7.1 0 0 0 .576-2.748 6.51 6.51 0 0 0-6.5-6.383zm-.985 19.377a3.005 3.005 0 0 1-2.977 2.626H6.534a3.01 3.01 0 0 1-2.978-2.638l-.872-6.362h7.32a1 1 0 0 0 0-2H2.41l-.38-2.771a1 1 0 0 1 .196-.842 1 1 0 0 1 .78-.374h8.015A6.51 6.51 0 0 0 17.387 13zm.552-12.36c.305-.001.589.135.78.373.19.238.263.544.183.922L17.662 11H17.5a4.505 4.505 0 0 1-4.47-3.984z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-glass-citrus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGlassCitrus;
